
<template>
  <table style="width:100%;" border="0">
    <tr>
      <td>
        <input-select3 style="max-width: 50px;" class="mt-1 col-1 px-0" v-model="el.TypeName" v-bind:options="[{Id:'',Text:'-'},{Id:'If',Text:'If'},{Id:'Before',Text:'Before created'},{Id:'After',Text:'After created'}]" idcolumnname="Id" textcolumnname="Text" />
        <input-select3 style="max-width: 50px; " class="ml-1 mt-1 col-1 px-0" v-model="el.Source" v-bind:options="elements" idcolumnname="Id" textcolumnname="Text" />
        <input-select3 style="max-width: 30px;" class="ml-1 mt-1 px-0" v-model="el.Requirement" v-bind:options="[{Id:'',Text:'-'},{Id:'Equals',Text:'='},{Id:'LessThan',Text:'<'},{Id:'MoreThan',Text:'>'},{Id:'LessThanOrEquals',Text:'<='},{Id:'MoreThanOrEquals',Text:'>='},{Id:'NotEquals',Text:'!='}]" idcolumnname="Id" textcolumnname="Text" />
        <input type="text" class="form-control ml-1 mt-1 col-2 px-0" v-model="el.SourceValue" style="display:inline-table;font-size:12px;line-height:20px;height:38px;" />
        <input-select3 style="max-width: 50px; " class="ml-1 mt-1 col-1 px-0" v-model="el.Action" v-bind:options="[{Id:'',Text:'-'},{Id:'Hide',Text:'Hide'},{Id:'Show',Text:'Show'},{Id:'Set',Text:'Set'},{Id:'Call',Text:'Call'},{Id:'Add',Text:'Add'},{Id:'Reset',Text:'Reset'},{Id:'Then',Text:'Then'},{Id:'Email',Text:'Email'},{Id:'Post',Text:'Post'}]" idcolumnname="Id" textcolumnname="Text" />
        <input-select3 style="max-width: 50px; " class="ml-1 mt-1 col-1 px-0" v-show="el.Action == 'Hide' || el.Action == 'Show' || el.Action != 'Call' && el.Action != 'Then' && el.Action != 'Mail' && el.Action != 'Post'" v-model="el.Target" v-bind:options="elements" idcolumnname="Id" textcolumnname="Text" />
        <input type="text" class="ml-1 mt-1 form-control mt-1 px-1 col-2 px-0" v-show="el.Action == 'Set'" v-model="el.TargetValue" style="display:inline-table;font-size:12px;line-height:20px;height:38px;" />
        <a class="ml-1 mt-1" href="#" @click="add(el)"><i class="icon-add"></i></a>
      </td>
    </tr>
    <tr v-if="el.Action == 'Email'">
      <td>
        <conditions-mail v-bind:value="el" ref="procedureSchConditionsMail" @change="conditionsChanged"></conditions-mail>
      </td>
    </tr>
    <tr v-if="el.Action == 'Post'">
      <td>
        <conditions-post v-bind:value="el" ref="procedureSchConditionsPost" @change="conditionsChanged"></conditions-post>
      </td>
    </tr>
  </table>
</template>

<script>
  export default {
    name: 'conditions-add',
    components: {
    },
    data(){
      return {
        el: {}
      }
    },
    props: {
      value: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
      list: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
    },
    methods: {
      add(el) {
        var elementToAdd = JSON.parse(JSON.stringify(el));
        this.$emit("add", elementToAdd)
        this.el = {};
      },
      setData(data) {
        this.value = data;
      },
      getFlat(elements, level) {
        var arr = [];
        if (level == 0) {
          arr.push({ Id: '', Text: '-' })
          /*
          arr.push({ Id: 'Priority', Text: 'Priority' })
          arr.push({ Id: 'Status', Text: 'Status' })
          arr.push({ Id: 'Assigned', Text: 'Assigned' })
          arr.push({ Id: 'Location', Text: 'Location' })
          arr.push({ Id: 'TeamName', Text: 'Team name' })
          arr.push({ Id: 'ProjectName', Text: 'Project name' })
          //arr.push({ Id: 'TimeSpentHours', Text: 'Time spent hours' })
          */
          arr.push({ Id: 'Value', Text: 'Value' })
        }
        level++;
        for (var i = 0; i < elements.length; i++) {
          if (elements[i].Text == "" || elements[i].Text == null)
            arr.push({ Id: elements[i].Id, Text: elements[i].Id.toString() });
          else
            arr.push({ Id: elements[i].Id, Text: elements[i].Text });
          var children = this.getFlat(elements[i].Elements, level);
          for (var k = 0; k < children.length; k++) {
            arr.push(children[k]);
          }
        }
        return arr;
      },
    },
  created() {

  },
  mounted() {
    //this.$root.$on('procedure_refresh', this.handleRefresh);
    //this.$root.$on('procedure_loaded', this.handleRefresh);
  },
    computed: {
      elements: {
        get() {
          var proc = this.procedure;
          var els = this.getFlat(proc.Elements, 0);
          return els;
        },
      },
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("update 21")
          this.$store.commit('saveprocedure', value)
        }
      },
      realValue() {
        return this.value != null ? this.value : this.list;
      },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/conditions/conditions-add.vue